import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
/** Import layout auto */
const requireComponent = require.context(
  '@/components', true, /[\w-]+\.vue$/
)
requireComponent.keys().forEach(fileName => {
  let newFilename = fileName.replace(/^\.\//g, '').replace(/\//g, '-').replace(/\.\w+$/, '')

  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(newFilename)
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})



// WEBPACK FOOTER //
// ./src/plugins/components.js